import BaseAccordionSummary from '@material-ui/core/ExpansionPanelSummary'

const AccordionSummary = BaseAccordionSummary

export default AccordionSummary
